import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class StatisticsPresenter extends EntityPresenter {
  static urn = 'statistics'

  static async nodesCommon(parentId = '') {
    return await this.get(`nodes/common/${ parentId }`)
  }

  static async getNodes() {
    return await this.get(`nodes/extended-tree`)
  }

  static async getNodesDaily() {
    return await this.get(`reporting/daily`)
  }

  static async nodesSummary(parentId = '') {
    return await this.get(`nodes/summary/${ parentId }`)
  }
}

bindPresenterMethods(StatisticsPresenter)
